import { ref, Ref, watch } from 'vue';
import { useStepperStore } from '../../stores/stepper.store.js';

export function useFormSubmitted(parentStepId: Ref<string | null>) {
  const isFormSubmitted = ref<boolean>(false);

  useStepperStore().subscribe((state) => {
    if (state.steps.steps.find((s) => s.stepId === parentStepId.value)?.isSubmitted) {
      isFormSubmitted.value = true;
    }
  });

  watch(parentStepId, (id: string | null) => {
    if (id) {
      isFormSubmitted.value = useStepperStore().getState().steps.steps.find((s) => s.stepId === id)?.isSubmitted || false;
    }
  })

  return { isFormSubmitted };
}